import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Clientes = lazy(() => import('./pages/Clientes'));
const NovoUsuario = lazy(() => import('./pages/NovoUsuario'));
const Almoxarifado = lazy(() => import('./pages/Almoxarifado'));
const ItensLoja = lazy(() => import('./pages/ItensLoja'));
const Fornecedores = lazy(() => import('./pages/Fornecedores'));
const Orcamentos = lazy(() => import('./pages/Orcamentos'));
const Vendas = lazy(() => import('./pages/Vendas'));
const ProducaoDoDia = lazy(() => import('./pages/ProducaoDoDia'));
const Configuracoes = lazy(() => import('./pages/Configuracoes'));
const Equipe = lazy(() => import('./pages/Equipe'));
const Freelancer = lazy(() => import('./pages/Freelancer'));
const Financeiro = lazy(() => import('./pages/Financeiro'));
const Avisos = lazy(() => import('./pages/Avisos'));
const OrdemCompra = lazy(() => import('./pages/OrdemCompra'));
const Veiculos = lazy(() => import('./pages/Veiculos'));
const Documentacao = lazy(() => import('./pages/Documentacao'));

const PageLoader = () => (
  <div className="flex items-center justify-center h-[60vh]">
    <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/novo-usuario" element={<NovoUsuario />} />
              <Route path="/almoxarifado" element={<Almoxarifado />} />
              <Route path="/itens-loja" element={<ItensLoja />} />
              <Route path="/fornecedores" element={<Fornecedores />} />
              <Route path="/orcamento" element={<Orcamentos />} />
              <Route path="/vendas" element={<Vendas />} />
              <Route path="/producao" element={<ProducaoDoDia />} />
              <Route path="/configuracoes" element={<Configuracoes />} />
              <Route path="/equipe" element={<Equipe />} />
              <Route path="/freelancer" element={<Freelancer />} />
              <Route path="/financeiro" element={<Financeiro />} />
              <Route path="/avisos" element={<Avisos />} />
              <Route path="/ordem-compra" element={<OrdemCompra />} />
              <Route path="/veiculos" element={<Veiculos />} />
              <Route path="/documentacao" element={<Documentacao />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Suspense>
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;
